export default __webpack_public_path__ + "static/media/myPic.aadaf9c1.png";